export const buttonCallbacks: Record<string, ContextMenu.HeaderButtonCallback> =
    {}

interface OldUIInit {
    registerButton: (
        actionId: string,
        callback: ContextMenu.HeaderButtonCallback,
    ) => void
}

const init = (): OldUIInit => {
    const registerButton = (
        actionId: string,
        callback: ContextMenu.HeaderButtonCallback,
    ): void => {
        buttonCallbacks[actionId] = callback
    }

    return {
        registerButton,
    }
}

export default init
